import { lazy } from "react";
export const SelectionAsync = lazy(()=>import("./SelectionPage"))